<div class="w-content" [class.mobile]="isMobileView()">
	<div [ngStyle]="layoutSizeStyles()">
		<ng-content></ng-content>
	</div>
</div>
